export default "__VITE_ASSET__DuU7Qlal__"